var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCnfIcon1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.99984 6.66667L8.15084 8.76733C9.2705 9.51378 10.7292 9.51378 11.8488 8.76733L14.9998 6.66667M4.99984 17.5H14.9998C16.8408 17.5 18.3332 16.0076 18.3332 14.1667V5.83333C18.3332 3.99238 16.8408 2.5 14.9998 2.5H4.99984C3.15889 2.5 1.6665 3.99238 1.6665 5.83333V14.1667C1.6665 16.0076 3.15889 17.5 4.99984 17.5Z",
    stroke: "#181D27",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCnfIcon1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/cnfIcon1.7ef319865f17745c26d9f4860c30662d.svg";